export default {
  title: 'Hvorfor vil du generere billedet igen?',
  description: "Fortæl os, hvad der var galt, så vi kan forbedre AI'en.",
  reasons: {
    wrong_style: 'Forkert stil',
    wrong_colors: 'Forkerte farver',
    wrong_food_item: 'Forkert ret',
    low_quality: 'Lav kvalitet',
    doesnt_match_brand: 'Passer ikke til mit brand',
    text_issues: 'Tekst eller labels er forkerte',
    other: 'Andet',
  },
  details_label: 'Andet? (valgfrit)',
  details_placeholder: 'Tilføj flere detaljer, så vi kan forstå det bedre…',
  cancel: 'Annuller',
  confirm: 'Generér igen',
};
